import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { wxCopilotContextManager } from 'utils/wxCopilotContextManager';

export function useWxCopilotPageContext(mountId = 'wx-copilot-root') {
  const location = useLocation();

  useEffect(() => {
    if (!mountId) return;
    const url = `${location.pathname}${location.search}${location.hash}`;
    wxCopilotContextManager.sendPageContext(url, mountId);
  }, [location, mountId]);

  useEffect(() => {
    if (!mountId) return undefined;
    return () => {
      wxCopilotContextManager.cleanup();
    };
  }, [mountId]);

  return useCallback(
    ({ title }) => {
      if (!mountId) return;
      const url = `${location.pathname}${location.search}${location.hash}`;
      wxCopilotContextManager.publishPageContext(url, title, mountId);
    },
    [location, mountId],
  );
}
